<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsAreaEspecifica"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :items="lstAreaEspecifica"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editInstituicao"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="instituicao.id === 0 ? addInstituicao() : editandoInstituicao()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="instituicao.id" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="instituicao.codinstituicao" required
              >Código</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="instituicao.descricao">Descrição</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Área específica',
      titleModal: '',
      titlePDF: 'Área específica',
      lstAreaEspecifica: [],
      baseUrlGestaoProjetosConcurso: '',
      instituicao: [],
      itemPorPage: '100',
      fieldsAreaEspecifica: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true }
      ]
    }
  },
  methods: {
    listandoAreaEspecifica: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listandoAreaEspecificaGenerico()
        .then((response) => {
          this.lstAreaEspecifica = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoAreaEspecifica()
  }
}
</script>
